import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SharedModule } from '../../../app.module.shared';

/**
 * This is a component that represent 3 fiscal data fields:
 * IvaCode - LegalName - FiscalAddress
 * 
 * It is barely a representation of those 3 form fields that are handled by the parent component.
 * Infact the parent component must include "ivaCode" , "fiscalAddress" , "legalName" in the form group
 * that it passes as input to this component.
 * 
 * 
 */

@Component({
  selector: 'input-fiscal-data',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './input-fiscal-data.component.html',
})
export class InputFiscalDataComponent {
  @Input() formGroup!: FormGroup;
  @Input() readonly = false;
  @Input() required = false;
  @Input() advancedPurchaseDaysRequired = true;

  toUppercase(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.toUpperCase();
    // force to update the partita iva in uppercase
    this.formGroup.get('ivaCode')?.setValue(input.value, { emitEvent: false });
  }

}
